import { AgencyPoliciesFilterOptionsEnum } from "../../../dtos/agency-policies-filter-options-enum";
import {
  areDatesEquals,
  FormattingDate,
} from "../../../utilities/dateFunctions";
import { BaseGridFilterParameters } from "../../BaseGrid/Hooks/useBaseGridFilters";

export const getDetaultTableFilterValues = (agencyId: number) => {
  const toDate = FormattingDate(new Date());
  const fromDate = FormattingDate(
    new Date(new Date().setDate(new Date().getDate() - 60))
  );
  return {
    filterId: AgencyPoliciesFilterOptionsEnum.CURRENT_ACTIVE,
    fromDate: fromDate,
    toDate: toDate,
    filterString: `filterId=${AgencyPoliciesFilterOptionsEnum.CURRENT_ACTIVE}&agencyID=${agencyId}&fromDate=${fromDate}&toDate=${toDate}`,
  };
};

export const getUpdatedDateFilter = (
  filterKey: string,
  currentValue: any,
  newValue: Date
) => {
  const isEqual = areDatesEquals(newValue, new Date(currentValue));
  if (isEqual === false) {
    return { [filterKey]: FormattingDate(newValue) };
  }
  return {};
};
export const validateIfInputShouldBeDisabled = (
  filter: BaseGridFilterParameters | null
) => {
  return (
    [
      AgencyPoliciesFilterOptionsEnum.CUSTOM_DATES,
      AgencyPoliciesFilterOptionsEnum.AUDITED,
      AgencyPoliciesFilterOptionsEnum.LOST_AND_DECLINED,
      AgencyPoliciesFilterOptionsEnum.CANCELLED,
    ].includes(filter?.filterValue ?? 0) === false
  );
};
